var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a1 1 0 0 0 1 1h14a1 1 0 0 0 0-2H1a1 1 0 0 0-1 1Zm1 6a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H1Zm0 5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H1Z",
    fill: "inherit"
  })));
};
export default SvgBurger;